'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pubSubClient = undefined;

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _requestFailed = require('conversations-async-data/async-data/operators/requestFailed');

var _requestStarted = require('conversations-async-data/async-data/operators/requestStarted');

var _requestStateUpdate = require('conversations-async-data/async-data/operators/requestStateUpdate');

var _requestSucceededWithOperator = require('conversations-async-data/async-data/operators/requestSucceededWithOperator');

var _actionTypes = require('../constants/actionTypes');

var _states = require('../constants/states');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var idenity = function idenity(f) {
  return f;
};
var initialState = (0, _AsyncData2.default)();

var pubSubClient = exports.pubSubClient = function pubSubClient() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.INITIALIZE_PUBSUB.STARTED:
      {
        return (0, _requestStarted.requestStarted)(state);
      }

    case _actionTypes.INITIALIZE_PUBSUB.SUCCEEDED:
      {
        return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
          return action.payload.client;
        }, state);
      }

    case _actionTypes.INITIALIZE_PUBSUB.FAILED:
      {
        return (0, _requestFailed.requestFailed)(state);
      }

    case _actionTypes.PUBSUB_READY:
      {
        return (0, _requestStateUpdate.requestStateUpdate)(_states.READY, idenity, state);
      }

    default:
      {
        return state;
      }
  }
};